import Footer from './components/Footer';
import LandingNav from './components/LandingNav';
import { footerNavigation } from './contentSections';

export default function AboutPage() {
  return (
    <div className='bg-background text-foreground'>
      <LandingNav />
      <main className='mx-auto max-w-3xl px-6 py-32 lg:px-8'>
        <h1 className='text-4xl font-bold mb-6'>About App</h1>
        <p className='text-muted-foreground text-lg leading-relaxed mb-6'>
          App is a community portal built for <span className='text-gradient-canada'>Canadian</span> 🍁 <span className='text-gradient-Member'>Members</span> — connecting Centers, community schools,
          charities, service providers, and individuals in one unified platform.
        </p>
        <p className='text-muted-foreground leading-relaxed mb-6'>
          Our mission is to strengthen the bonds of the community by making it easy for
          organizations to share announcements, events, services, and resources — and for community
          members to find what they need, close to home.
        </p>
        <p className='text-muted-foreground leading-relaxed mb-6'>
          Whether you are looking for a local Center, a community school, or a charity to support,
          App brings the community together in one place.
        </p>
        <h2 className='text-2xl font-semibold mt-10 mb-4'>Our Values</h2>
        <ul className='list-disc list-inside space-y-2 text-muted-foreground leading-relaxed'>
          <li>Community first — built by and for the <span className='text-gradient-Member'>Member</span> community</li>
          <li>Transparency and trust in everything we do</li>
          <li>Inclusivity across all backgrounds and traditions</li>
          <li>Empowering organizations to serve their communities better</li>
        </ul>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}



